import { SegmentSkin } from "../tail/SegmentSkin";
import type { Charge, ChargeFireContext } from "./Charge";
import { singleBeamPattern } from "../weapons/patterns/SingleBeamPattern";

/**
 * Basic straight laser charge.
 *
 * NOTE: Patterns are a Strategy layer that lets us add triple-beam/lightning
 * later without changing GameModel or input handling.
 */
export class LaserCharge implements Charge {
  readonly id = "laser.basic";
  readonly label = "Laser";
  readonly skin = SegmentSkin.Purple;

  fire(ctx: ChargeFireContext): void {
    singleBeamPattern.fire(ctx);
  }
}
